import { takeLatest, put } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';
import { APP_DETAILS } from '../config';
import { ADD_WELCOMEIDS_TO_DOWNLOAD } from '../constants/download';
import { deleteWelcomeIDS, installSoft } from '../actions/native';

function* fetchWelcomeIdDetail({ ids }) {
  const axios = yield createAxios();
  for (let i = 0; i < ids.length; i += 1) {
    try {
      const res = yield axios.get(APP_DETAILS, {
        params: { softid: ids[i] },
      });
      if (res.data.status === 0) {
        const softData = res.data.data;
        softData.downLoadUrl = softData.downloadUrl;
        // 添加到下载
        yield put(installSoft(softData));
      }
    } catch (error) {
      logNative(`获取欢迎页数据 fetchWelcomeIdDetail 错误${error}`, error);
    }
  }
  yield put(deleteWelcomeIDS(ids));
}

export function* watchFetchWelcomeIdDetail() {
  yield takeLatest(ADD_WELCOMEIDS_TO_DOWNLOAD, fetchWelcomeIdDetail);
}
